import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import { CURRENCIES } from "@/shared/constants";
import { useAppDispatch, useAppSelector } from "@/app/store";
import { selectCurrencyCode, setCurrency } from "@/app/store/slices/ui.slice";

export function CurrencySelector() {
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const currencyCode = useAppSelector(selectCurrencyCode);
  const currency = CURRENCIES.find((c) => c.code === currencyCode);

  const handleSelect = (code: string) => {
    dispatch(setCurrency(code));
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "flex items-center gap-1.5 px-3 py-1.5",
          "rounded-lg border border-grey-100",
          "bg-grey-100 hover:bg-green-50",
          "text-sm font-medium transition-colors",
        )}
      >
        {currency?.symbol(true)}
        <span>{currency?.code}</span>
        <ChevronDown
          className={cn("w-4 h-4 transition-transform", isOpen && "rotate-180")}
        />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div
            className={cn(
              "absolute top-full mt-1 end-0 z-50",
              "min-w-[140px] py-1",
              "bg-white border border-grey-100 rounded-lg shadow-lg",
              "animate-fade-in",
            )}
          >
            {CURRENCIES.map((curr) => (
              <button
                key={curr.code}
                onClick={() => handleSelect(curr.code)}
                className={cn(
                  "w-full flex items-center gap-2 px-3 py-2",
                  "text-sm text-start hover:bg-green-50 transition-colors",
                  currency?.code === curr.code && "bg-green-50 font-medium",
                )}
              >
                <span className="w-6">{curr.symbol()}</span>
                <span>{curr.code}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
